import { occupancyQueryKeys as e } from "./useCalendarQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { calendarApi as n } from "@maat/api-main";
//#region src/calendar/useWorkspaceOccupancyQuery.ts
var r = (r, i = 6) => t({
	queryKey: e.forWorkspace(r, i),
	queryFn: () => n.getWorkspaceOccupancy(i),
	enabled: !!r
});
//#endregion
export { r as useWorkspaceOccupancyQuery };
